import { useEffect, useState } from 'react'
import { api, type FindingsCell, type FindingsList, type FindingsScope } from './api.ts'

/**
 * One page of the findings behind a number, asked again when the page changes.
 * The previous page stays up while the next loads, so the modal keeps its height.
 *
 * The scope and the cell are read once: the modal is opened for one number and
 * closed before another is.
 */
export function useFindingsList(
  scope: FindingsScope,
  cell: FindingsCell,
  page: number,
): { list: FindingsList | undefined; loading: boolean; error: string | undefined } {
  const [asked] = useState({ scope, cell })
  const [list, setList] = useState<FindingsList | undefined>()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | undefined>()

  useEffect(() => {
    let current = true
    setLoading(true)
    setError(undefined)
    api
      .findingsList(asked.scope, asked.cell, page)
      .then((next) => {
        if (current) setList(next)
      })
      .catch((cause: unknown) => {
        if (current) setError(cause instanceof Error ? cause.message : 'falhou')
      })
      .finally(() => {
        if (current) setLoading(false)
      })
    return () => {
      current = false
    }
  }, [asked, page])

  return { list, loading, error }
}
